import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-30",
  "use": "icon-sheet_icon-30-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-30\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M4 14a8 8 0 1016 0\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 14V5.964L12 2l8 3.964v7.994\" /><path stroke-linecap=\"round\" d=\"M8 12h8M12 8v8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol